import { RowSectorTripPatternDto, RowTripPatternCheckpointDto, RowTripPatternStopDto, TripPatternCheckpointExportDto } from "@/dtos";
import { TripPatternCheckpoint } from "@/entities";
import { getTripPatternCheckpointGeofenceMarkOption, getTripPatternCheckpointTypeOption } from "@/helpers/options";
import { convertSecondsToTime } from "@/helpers/utilities";
import { MapCheckpoint } from "@/ui/components/maps/common/interfaces/map-checkpoint";
import { MapLine } from "@/ui/components/maps/common/interfaces/map-line";

export const formatRowTripPatternCheckpointDto = (tripPatternCheckpoints: TripPatternCheckpoint[]): RowTripPatternCheckpointDto[] => {
    return tripPatternCheckpoints.map((x) => {
        const row: RowTripPatternCheckpointDto = {
            ...x,
            type_label: getTripPatternCheckpointTypeOption(x.type).label,
            time_between_checkpoints_label: convertSecondsToTime(x.time_between_checkpoints),
            checkpoint_label: (x.checkpoint?.name) ? x.checkpoint.name : 'S/N',
            active: (x.is_active) ? 'Activo' : 'Inactivo',
            is_sanctionable_label: (x.is_sanctionable) ? 'Si' : 'No',
        }

        return row;
    });
}

export const formatCheckpointCoordsToMap = (rows: RowTripPatternCheckpointDto[]) => {
    const mapCoordinates: MapCheckpoint[] = [];
    rows.sort((a, b) => a.order - b.order);
    for (const row of rows) {
        const mapCoordinate: MapCheckpoint = {
            name: row.checkpoint.name,
            coordinate: [row.checkpoint.longitude, row.checkpoint.latitude],
            isPrimaryColor: row.is_active,
            radio: row.checkpoint.radio ?? 10
        }
        mapCoordinates.push(mapCoordinate);
    }

    const mapLine: MapLine = {
        identification: "Line 1",
        coordinates: mapCoordinates
    };

    return [mapLine];
}

export const getLastOrder = (rows: RowTripPatternCheckpointDto[] | RowSectorTripPatternDto[] | RowTripPatternStopDto[]): number => {
    let num = 0;
    for (const row of rows) {
        if (row.order > num) {
            num = row.order;
        }
    }

    return num;
}

export const formatTripPatterCheckpointExportDto = (list: TripPatternCheckpoint[]) => {
    return list.map(x => {
        const row: TripPatternCheckpointExportDto = {
            order: x.order,
            checkpoint: x.checkpoint.name,
            time_between_checkpoints_label: convertSecondsToTime(x.time_between_checkpoints),
            geofence_mark_label: getTripPatternCheckpointGeofenceMarkOption(x.geofence_mark).label,
            type_label: getTripPatternCheckpointTypeOption(x.type).label,
            is_sanctionable_label: x.is_sanctionable ? 'Si' : 'No',
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}